var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "file-item-body",
        class: { "file-item-selected": _vm.fileItem.selected }
      },
      [
        _vm.fileItem.data_type != 3 && _vm.showCkeakBtn
          ? _c(
              "div",
              {
                staticClass: "item-selected",
                on: { click: _vm.clickSelectedItem }
              },
              [
                !_vm.fileItem.selected
                  ? _c("img", {
                      attrs: {
                        src: require("@/assets/ic_selected_n.png"),
                        alt: ""
                      }
                    })
                  : _c("img", {
                      attrs: {
                        src: require("@/assets/ic_selected_y.png"),
                        alt: ""
                      }
                    })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "item-body" }, [
          _c("div", { staticClass: "file-icon" }, [
            (_vm.fileItem.file_type == 1 || _vm.fileItem.file_type == 2) &&
            _vm.fileItem.thumb != "" && _vm.fileItem.thumb != null
              ? _c("img", { attrs: { src: _vm.fileItem.thumb, alt: "Icon" } })
              : _c("img", {
                  attrs: {
                    src: _vm.fileIcon[_vm.fileItem.file_type],
                    alt: "Icon"
                  }
                })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "file-content" }, [
            _c("div", { staticClass: "file-name" }, [
              _vm._v("\n          " + _vm._s(_vm.fileItem.title) + "\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "file-time" }, [
              _vm._v("\n          " + _vm._s(_vm.fileItem.createtime) + " "),
              _vm.fileItem.data_type != 3
                ? _c("label", [_vm._v(_vm._s(_vm.fileItem.size))])
                : _vm._e()
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51b72916", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51b72916","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/file_item.vue
// module id = null
// module chunks = 